import { Storage } from "./tools"
import { useCommon } from "@/store/useCommon";
import pinia from '@/store'
import { getPlatformList, getBrandList, getAllLangApi, getCountriesApi } from '@/api/common/index'
import {ref, computed} from 'vue'
// import { getBroadCastListApi, getGenresApi, getVodLanguageApi } from '@/api/vod'
// import { getAgentProtocolApi, getDocumentDownloadApi } from '@/api/operating'

type ResType = {
  code: string,
  data: any,
  [propName: string]: any
}
const storeCommon = useCommon()

const user = computed(() => useCommon().userData)

// 缓存数据
const cachesData = ref({

})

export const PrefixInteger = (num, length) => {
  return ("0000000000000000" + num).substr(-length);
}

// 获取品牌列表数据
export const useBrandsByUser = async (params?) => {
  let ids = user.value.cid && user.value.cid.join(',')
  let data = Storage.sessionGet('Brands')
  if (data) {
    return data
  } else {
    let res = await getBrandList({ cids: ids, ...params }) as ResType
    if (res.code == '0') {
      let resData = res.data.map(item => ({
        ...item,
        prefixName: PrefixInteger(item.cid, 3) + '-' + item.name
      }))
      Storage.sessionSet('Brands', resData)
      return resData
    }
    return []
  }
}

// 获取平台数据
export const usePlatformsByUser = async (params?) => {
  let ids = user.value.cid && user.value.cid.join(',')
  let data = Storage.sessionGet('Platforms')
  if (data) {
    return data
  } else {
    let res = await getPlatformList({ cids: ids, lessThan: 255, ...params }) as ResType
    if (res.code == '0') {
      let resData = res.data.map(item => ({
        ...item,
        prefixName: PrefixInteger(item.pid, 3) + '-' + item.name
      }))
      Storage.sessionSet('Platforms', resData)
      return resData
    }
    return []
  }
}

// 获取所有语言
export const useLanguages = async () => {
  let langs = Storage.sessionGet('langs')
  if (langs) {
    return langs
  } else {
    let { code, data } = await getAllLangApi() as ResType
    if (code === '0') {
      let resData = data.map(item => ({
        label: item.name,
        value: item.id,
        symbol: item.symbol
      }))
      Storage.sessionSet('langs', resData)
      return resData
    }
    return []
  }
}

// 获取点播相关的语言
// export const useVodLanguages = async () => {
//   let langs = Storage.sessionGet('vodLangs')
//   if (langs) {
//     return langs
//   } else {
//     let { code, data } = await getVodLanguageApi() as ResType
//     if (code === '0') {
//       let resData = data.map(item => ({
//         label: item.name,
//         value: item.key,
//         labelValue: item.name
//       }))
//       Storage.sessionSet('vodLangs', resData)
//       return resData
//     }
//     return []
//   }
// }

// 获取所有国家
export const useCountryList = async () => {
  let langs = Storage.sessionGet('countries')
  if (langs) {
    return langs
  }else {
    let { code, data } = await getCountriesApi() as any
    if (code === '0') {
      let resData = data.map(item => ({
        label: item.label,
        value: item.label,
        abbValue: item.value
      }))
      Storage.sessionSet('countries', resData)
      return resData
    }
    return []
  }
}


// // 获取分辨率
// export const useBroadCastList = async () => {
//   let broadCast = Storage.sessionGet('broadCast')
//   if (broadCast) {
//     return broadCast
//   } else {
//     let { code, data } = await getBroadCastListApi({}) as ResType
//     if (code === '0') {
//       Storage.sessionSet('broadCast', data)
//       return data
//     }
//     return []
//   }
// }


// // 获取文档下载列表
// export const useDocumentDownloadList = async () => {
//   let downloadList = Storage.sessionGet('downloadList')
//   if (downloadList) {
//     return downloadList
//   } else {
//     let { code, data } = await getDocumentDownloadApi({}) as ResType
//     if (code === '0') {
//       let resData = data.map((item, index) => {
//         return {
//           ...item,
//           no: index + 1,
//         }
//       })
//       Storage.sessionSet('downloadList', resData)
//       return resData
//     }
//     return []
//   }
// }

// // 获取关联分类列表
// export const useGenresList = async (language, type) => {
//   let GenresList = Storage.sessionGet('GenresList') || {}
//   if (GenresList && GenresList[type] && GenresList[type][language]) {
//     return GenresList[type][language]
//   } else {
//     let { code, data } = await getGenresApi({ language, type }) as ResType
//     if (code === '0') {
//       if (!GenresList.hasOwnProperty(type)) {
//         GenresList[type] = {}
//         if (!GenresList[type].hasOwnProperty(language)) {
//           GenresList[type][language] = data
//         }
//       } else {
//         if (!GenresList[type].hasOwnProperty(language)) {
//           GenresList[type][language] = data
//         }
//       }
//       Storage.sessionSet('GenresList', GenresList)
//       return data
//     }
//     return []
//   }
// }

// // 获取协议
// export const useAgentProtocolList = async () => {
//   let agentProtocolList = Storage.sessionGet('agentProtocolList')
//   if (agentProtocolList) {
//     return agentProtocolList
//   } else {
//     let { code, data } = await getAgentProtocolApi() as ResType
//     if (code === '0') {
//       Storage.sessionSet('agentProtocolList', data)
//       return data
//     }
//     return []
//   }
// }
